import style from '../style/ManaMenu.module.less';
import { manaRouter } from '@/pages/mana/router';
import { useState } from 'react';
import { RouterWithMeta } from '@/router';
import IconFont from '@/common/IconFont';
import { NavLink, useLocation } from 'react-router-dom';


interface InitialRouter extends RouterWithMeta {
  show: boolean;
}
const Folder: React.FC<{
  item: InitialRouter;
  toggleMenu: (path: string) => void;
}> = ({ item, toggleMenu }) => {

  const folderClick = (path: string) => {
    toggleMenu(path);
  };

  const location = useLocation();
  return (
    <>
      <div
        className={
          `${style.folder}
          ${item.children?.some(i => location.pathname.includes(item.path + '/' + i.path)) ? style.active : ''}
        `}
        onClick={() => folderClick(item?.path as string)}
      >
        <div>
          <IconFont type={item.meta?.icon as string}></IconFont>
          <span>{item.meta?.name}</span>
        </div>
        <IconFont type="icon-zhankai"></IconFont>
        {/* 子菜单？ */}
      </div>
      <div
        className={`${style.subMenuWrapper} ${item.show ? '' : style.hideSubMenu}`}
        style={{height: `${item.children?.length as number * 40}px`}}
      >
        {
          item.children?.map(i => {
            return (
              <div className={style.subMenu} key={i.path as string}>
                <NavLink className={style.link} to={item?.path + '/' + i.path as string}>{i.meta?.name}</NavLink>
              </div>
            );
          })
        }
      </div>
    </>
  );
};

// 子菜单
interface MenuItemProps {
  item: InitialRouter;
}
const MenuItem: React.FC<MenuItemProps> = prop => {
  const { item } = prop;
  return (
    <NavLink to={item.path as string} className={style.menuItem}>
      <IconFont type={item.meta?.icon as string}></IconFont>
      <span>{item.meta?.name}</span>
    </NavLink>
  );
};
const ManaMenu = () => {
  const initialRouter = manaRouter.filter(i => !i.meta?.isRedirect).map(i => {
    return {
      ...i,
      show: location.href.includes(i.path as string)
    };
  });
  const [routerArr, setRouterArr] = useState(initialRouter);
  const toggleMenu = (path: string) => {
    setRouterArr(routerArr.map(i => {
      return {
        ...i,
        show: i.path === path ? !i.show : i.show
      };
    }));
  };
  return (
    <div className={style.wrapper}>
      {
        routerArr.map(i =>
          i.children ?
            <Folder
              key={i.path}
              item={i}
              toggleMenu={toggleMenu}
            /> :
            <MenuItem
              item={i}
              key={i.path}
            />
        )
      }
    </div>
  );
};

export default ManaMenu;